module.exports = __webpack_public_path__ + "img/artdtl_home.36ea63ac.png";